import { Ikpi } from './interfaces';

export const initState: Ikpi = {
  EnergySite: {
    '1day': [],
  },
  EnergyCommunity: {
    '1day': [],
  },
  EnergyMember: {
    '1day': [],
  },
  EconomicsSite: {
    '1day': [],
  },
  EconomicsCommunity: {
    '1day': [],
  },
  EconomicsMember: {
    '1day': [],
  },
  AncillarySite: {
    '1day': [],
  },
  AncillaryCommunity: {
    '1day': [],
  },
  AncillaryMember: {
    '1day': [],
  },
  communityRanking: {},
  memberRanking: {},
};